var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTigerSad(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 320,
    height: 320,
    viewBox: "0 0 320 320",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_83_7410)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M320 313.765C320 317.31 248.318 320.122 160 320.122C71.682 320.122 0 317.188 0 313.765C0 310.221 71.682 307.409 160 307.409C248.318 307.409 320 310.221 320 313.765Z",
    fill: "#E4CBD8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.128 313.888H220.306V296.164L165.505 292.375L154.128 313.888Z",
    fill: "#932F31"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M302.997 311.321C302.263 312.421 289.052 313.522 273.884 314.01H273.761C259.449 314.499 243.425 314.377 234.251 312.91C215.168 310.099 188.868 288.952 183.364 272.939C183.853 273.428 199.511 288.463 230.214 297.753C245.137 302.276 258.715 302.276 269.48 301.054C281.223 299.831 289.786 297.264 293.578 297.753C300.917 298.853 304.465 309.243 302.997 311.321Z",
    fill: "url(#paint0_linear_83_7410)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M302.997 311.322C302.263 312.422 289.052 313.522 273.884 314.011H273.762C277.187 305.577 269.847 301.298 269.48 301.054C281.224 299.832 289.786 297.265 293.578 297.754C300.918 298.854 304.465 309.244 302.997 311.322Z",
    fill: "url(#paint1_radial_83_7410)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M211.132 290.542C211.132 290.542 212.477 293.109 212.844 304.232L217.982 307.166C217.982 307.166 219.939 300.321 220.184 294.331L211.132 290.542Z",
    fill: "#9D3D3A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M228.135 297.142C228.135 297.142 231.071 302.275 227.279 311.321L231.56 312.543C231.56 312.543 235.23 307.654 234.374 298.975L228.135 297.142Z",
    fill: "#9D3D3A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M242.813 300.688C242.813 300.688 246.116 302.643 246.116 311.689C246.116 311.689 250.275 306.799 249.174 301.421L242.813 300.688Z",
    fill: "#9D3D3A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M257.615 301.787C257.615 301.787 262.997 303.254 263.609 311.688C263.609 311.688 265.077 306.066 263.976 301.543L257.615 301.787Z",
    fill: "#9D3D3A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.1651 303.62C38.1651 303.62 25.4433 299.953 20.6727 303.009C15.9021 306.065 20.0611 315.355 20.0611 315.355H68.5015L69.847 304.231L38.1651 303.62Z",
    fill: "#932F31"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M225.932 317.922C225.443 317.678 219.449 314.5 213.333 315.355C206.85 316.333 198.042 317.311 192.049 316.7C186.177 316.089 179.082 311.322 178.593 311.077H178.471C178.348 311.077 178.226 311.077 178.104 311.199C177.737 311.322 177.125 311.444 176.269 311.688C175.902 311.811 175.535 311.811 175.168 311.933C168.685 313.155 153.761 315.233 131.987 313.033C131.865 313.033 131.743 313.033 131.743 313.033C131.743 313.033 131.987 316.578 129.052 317.556C125.993 318.534 96.758 318.045 96.758 318.045C96.758 318.045 97.2473 308.877 87.9507 304.843C87.9507 304.843 113.761 293.475 127.951 269.639C127.951 269.639 134.679 268.662 143.119 266.095C151.559 263.528 166.238 259.372 175.045 264.017C183.853 268.662 205.382 296.165 207.828 296.531C210.275 296.898 211.62 295.92 213.7 296.531C215.779 297.142 234.25 307.899 234.984 309.121C235.718 310.344 234.128 316.822 225.932 317.922Z",
    fill: "url(#paint2_radial_83_7410)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.801 275.751L128.563 274.773C128.563 274.773 128.44 275.017 128.074 275.384C127.951 275.506 127.951 275.629 127.829 275.629C127.707 275.751 127.707 275.873 127.584 275.873C127.462 275.995 127.34 276.24 127.217 276.362C127.095 276.484 126.973 276.729 126.85 276.851C126.728 276.973 126.606 277.218 126.483 277.462C126.361 277.707 126.116 277.951 125.872 278.196C125.749 278.44 125.505 278.685 125.382 278.929C124.893 279.54 124.404 280.274 123.914 280.885C123.548 281.374 123.058 281.985 122.691 282.474C122.569 282.596 122.447 282.718 122.447 282.841C121.957 283.452 121.468 284.063 120.979 284.674C120.856 284.796 120.734 284.919 120.612 285.163C120.367 285.407 120.122 285.774 119.878 286.141C119.633 286.385 119.388 286.752 119.022 287.119C118.532 287.608 118.165 288.097 117.676 288.586C117.554 288.708 117.431 288.83 117.309 288.952C117.064 289.197 116.697 289.563 116.453 289.93C114.862 291.641 113.272 293.231 111.56 294.82C111.315 295.064 111.193 295.186 110.948 295.431C110.581 295.675 110.337 296.042 109.97 296.286C109.358 296.898 108.624 297.386 108.012 297.875C107.645 298.12 107.401 298.364 107.034 298.609C106.055 299.342 105.077 299.953 103.976 300.565C91.4986 307.899 65.1989 308.51 56.8809 309.854C48.5628 311.199 45.7494 312.91 45.7494 312.91C45.7494 312.91 40.3671 310.343 39.0215 306.554C39.0215 306.554 35.4741 305.454 33.7616 304.721C33.7616 304.721 33.6393 304.721 33.5169 304.598C32.1714 303.865 27.6454 300.809 22.9971 296.653C19.939 293.842 16.8809 290.541 14.679 287.119L10.7646 288.341C10.7646 288.341 12.4772 286.141 14.5567 282.596C16.6362 279.173 19.3273 274.406 21.2845 269.517C25.3212 259.494 30.0919 240.303 33.15 235.658C33.6393 234.802 34.4955 233.824 35.7188 232.724C41.101 227.468 52.9665 220.134 67.2784 219.767L62.2631 215C62.2631 215 85.8717 217.811 98.3487 229.302C110.826 240.914 118.41 264.016 134.801 275.751Z",
    fill: "url(#paint3_radial_83_7410)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.062 231.135C100.062 231.135 111.193 235.413 124.404 238.347C137.615 241.28 131.866 260.593 120.49 260.838C120.612 260.716 107.646 240.302 100.062 231.135Z",
    fill: "url(#paint4_linear_83_7410)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.829 275.751C127.707 275.995 127.462 276.24 127.217 276.607C127.095 276.729 126.973 276.973 126.85 277.096C126.728 277.218 126.606 277.462 126.483 277.707C126.361 277.951 126.117 278.196 125.872 278.44C125.75 278.685 125.505 278.929 125.383 279.174C124.893 279.785 124.404 280.518 123.915 281.129C123.548 281.618 123.058 282.229 122.691 282.718C122.569 282.841 122.447 282.963 122.447 283.085C121.957 283.696 121.468 284.307 120.979 284.919C120.857 285.041 120.734 285.163 120.612 285.408C120.367 285.652 120.123 286.019 119.878 286.385C119.633 286.63 119.389 286.997 119.022 287.363C118.655 287.852 118.165 288.341 117.676 288.83C117.554 288.952 117.431 289.075 117.309 289.197C117.065 289.441 116.698 289.808 116.453 290.175C114.863 291.886 113.272 293.475 111.56 295.064C111.315 295.309 111.193 295.431 110.948 295.675C110.581 295.92 110.337 296.286 109.97 296.531C109.358 297.142 108.624 297.631 108.013 298.12C107.646 298.364 107.401 298.609 107.034 298.853C106.055 299.587 105.077 300.198 103.976 300.809C91.4988 308.143 65.1991 308.754 56.881 310.099C48.563 311.444 45.7495 313.155 45.7495 313.155C45.7495 313.155 40.3673 310.588 39.0217 306.799C39.0217 306.799 35.4743 305.699 33.7618 304.965C33.7618 304.965 33.6394 304.965 33.5171 304.843C32.0492 304.232 27.1563 302.032 22.2633 297.509C19.4498 294.942 16.6364 291.519 14.6792 287.241C21.407 285.53 31.3153 290.052 31.3153 290.052C43.4254 292.253 53.3336 290.052 53.3336 290.052C53.3336 290.052 56.5141 289.441 59.9391 289.564C63.3642 289.686 81.2235 297.509 100.184 293.72C115.719 290.541 124.771 279.785 127.584 276.118C127.707 275.995 127.829 275.873 127.829 275.751Z",
    fill: "url(#paint5_radial_83_7410)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.695 285.896C60.3066 288.83 73.1507 291.886 81.8357 288.585C90.5207 285.285 93.8234 281.862 94.3127 279.295C94.6797 276.728 97.2485 271.839 92.2332 266.216C87.2179 260.593 81.958 260.227 75.7195 255.337C69.6033 250.448 68.2577 249.226 66.7898 249.226C65.3219 249.348 54.5574 261.571 59.695 285.896Z",
    fill: "url(#paint6_radial_83_7410)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.0426 282.841C37.064 285.408 31.9264 287.363 27.7674 286.385C23.6083 285.408 20.3056 283.574 19.9386 280.396C19.5716 277.218 21.1619 269.395 25.5655 264.872C31.0701 259.127 35.8408 252.526 37.9203 252.16C40.1221 251.793 40.856 275.14 38.0426 282.841Z",
    fill: "url(#paint7_radial_83_7410)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.134 242.014C108.134 242.014 112.783 244.458 121.957 246.659C131.131 248.859 127.706 260.104 120.611 260.716C120.611 260.716 110.091 246.17 108.134 242.014Z",
    fill: "url(#paint8_radial_83_7410)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.8773 267.561C39.8773 267.561 39.1433 255.093 36.9415 255.093C34.6173 254.971 34.3727 258.394 29.969 262.794C25.5653 267.194 21.8956 270.373 20.6724 274.895C20.6724 274.895 21.284 269.884 23.9751 266.217C26.5439 262.55 33.0271 256.682 35.4736 253.382C37.7977 250.082 38.287 249.47 39.2656 249.959C39.9996 250.326 40.4889 263.038 39.8773 267.561Z",
    fill: "#9D3D3A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.7158 266.46C58.7158 266.46 61.2846 248.614 66.9115 247.147C72.5385 245.68 74.1287 254.97 84.2816 260.471C94.4345 265.971 96.0247 269.638 94.9238 276.239C94.9238 276.239 95.78 268.661 88.0736 264.994C78.043 260.226 73.1501 255.092 69.9696 252.159C66.7892 249.347 62.6302 249.959 58.7158 266.46Z",
    fill: "#9D3D3A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.9941 283.33C85.7494 283.697 85.3825 284.063 85.0155 284.308C78.043 290.053 63.1195 288.342 62.1409 284.308C61.5292 281.863 61.2846 279.052 61.1623 276.118C61.0399 268.295 63.3641 260.472 69.9696 260.594C78.777 260.839 90.7647 276.729 85.9941 283.33Z",
    fill: "url(#paint9_radial_83_7410)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.1652 282.596C38.1652 282.718 38.0429 282.84 38.0429 282.963C37.0643 285.407 29.8472 286.385 26.2998 284.063C25.3212 283.451 24.9542 281.618 25.1989 279.418C25.6882 273.55 29.4802 264.505 33.7616 263.894C39.5108 263.038 40.4894 276.362 38.1652 282.596Z",
    fill: "url(#paint10_radial_83_7410)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.1657 282.596C38.1657 282.718 38.0434 282.841 38.0434 282.963C37.6764 283.819 36.4532 284.552 34.863 285.041C33.7621 285.285 32.5388 285.53 31.3156 285.408C29.4807 285.408 27.6459 284.919 26.3003 284.063C25.3217 283.452 24.9547 281.618 25.1994 279.418C25.5663 279.051 26.9119 277.829 31.9272 279.296C32.2942 279.418 32.5388 279.54 32.9058 279.54C34.129 279.907 34.9853 280.396 35.8416 280.763C36.9425 281.496 37.6764 282.107 38.1657 282.596Z",
    fill: "url(#paint11_linear_83_7410)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.9937 283.33C85.749 283.696 85.382 284.063 85.0151 284.308C82.0793 286.752 77.6756 287.852 73.5166 287.975C71.9264 288.097 70.2138 287.975 68.746 287.73C65.1986 287.241 62.5074 285.897 62.1404 284.308C61.6512 282.352 61.4065 280.152 61.2842 277.951C61.2842 277.34 61.2842 276.729 61.2842 276.24C61.2842 276.24 61.7735 276.118 62.7521 276.118C64.4646 275.996 67.5227 275.873 71.1924 276.607C73.0273 276.973 75.1068 277.462 77.3086 278.318C80.1221 279.418 83.0579 281.007 85.9937 283.33Z",
    fill: "url(#paint12_linear_83_7410)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.3086 278.318C75.2291 277.462 73.1496 276.973 71.1924 276.607C67.5227 275.873 64.4646 275.996 62.7521 276.118C61.7735 276.24 61.2842 276.24 61.2842 276.24C61.2842 276.851 61.2842 277.462 61.2842 277.951C61.4065 280.152 61.7735 282.352 62.1404 284.308C62.5074 285.897 65.1986 287.241 68.746 287.73C70.2138 287.975 71.8041 288.097 73.5166 287.975C75.8408 286.141 77.3086 283.085 77.3086 279.663C77.431 279.296 77.431 278.807 77.3086 278.318Z",
    fill: "url(#paint13_radial_83_7410)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.9057 281.374C72.9057 284.308 71.1932 286.874 68.869 287.852C65.3216 287.363 62.6305 286.019 62.2635 284.43C61.7742 282.474 61.5296 280.274 61.4072 278.074C61.7742 277.34 62.2635 276.729 62.7528 276.118C64.4653 275.996 67.5234 275.873 71.1932 276.607C72.2941 277.829 72.9057 279.418 72.9057 281.374Z",
    fill: "#75272C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.9054 279.54C32.5384 279.418 32.2938 279.296 31.9268 279.296C26.9115 277.829 25.566 279.051 25.199 279.418C25.0767 281.618 25.3213 283.452 26.2999 284.063C27.6455 284.919 29.4803 285.408 31.3152 285.408C32.5384 285.408 33.7617 285.285 34.8626 285.041C35.3519 283.819 35.7189 282.474 35.7189 280.885C34.9849 280.396 34.0063 280.029 32.9054 279.54Z",
    fill: "url(#paint14_radial_83_7410)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.9058 280.518C33.0281 282.596 32.2942 284.307 31.3156 285.408C29.4807 285.408 27.6459 284.919 26.3003 284.063C25.3217 283.452 24.9547 281.618 25.1994 279.418C25.5663 279.051 26.9119 277.829 31.9272 279.296C32.2942 279.418 32.5388 279.54 32.9058 279.54C32.9058 279.907 32.9058 280.151 32.9058 280.518Z",
    fill: "#75272C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.0764 280.274L22.1406 278.074C22.1406 278.074 24.5871 277.585 29.847 278.318C34.9847 279.052 38.1651 282.596 38.1651 282.596C38.1651 282.596 33.8837 278.807 25.1987 279.418L25.0764 280.274Z",
    fill: "#75272C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.4065 277.951L57.9814 276.24C57.9814 276.24 72.7827 270.861 86.116 283.329C86.116 283.329 77.1863 276.484 62.2628 276.729L61.4065 277.951Z",
    fill: "#75272C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.8956 282.474C61.8956 282.474 60.4277 285.041 60.4277 286.018C60.4277 286.996 65.5653 288.83 72.9048 288.708C80.2442 288.585 84.8926 284.796 85.9935 283.452C85.9935 283.452 82.4461 287.485 73.2718 287.852C63.9751 288.219 62.6296 284.918 62.6296 284.918L61.8956 282.474Z",
    fill: "#BD4C3A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.1929 289.93C31.1929 289.93 34.4956 285.652 39.2663 283.696C39.2663 283.696 47.462 280.273 54.3121 284.674V289.685C54.3121 289.808 45.8718 293.108 31.1929 289.93Z",
    fill: "#FF9F30"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.1926 289.93C31.1926 289.93 30.3363 291.519 31.1926 292.375L36.8195 296.164H39.3883C39.3883 296.164 46.7277 292.375 53.5779 293.475C53.5779 293.475 54.4342 291.397 54.1895 289.686C54.3118 289.808 44.8929 291.886 31.1926 289.93Z",
    fill: "url(#paint15_radial_83_7410)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.9424 304.72C36.9424 304.72 40.4898 303.864 46.7283 304.72C52.9668 305.576 56.3919 307.776 56.3919 307.776C56.3919 307.776 53.2115 306.431 46.7283 305.82C40.1228 305.209 36.9424 304.72 36.9424 304.72Z",
    fill: "url(#paint16_radial_83_7410)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.9825 317.922L67.2791 318.044C67.2791 318.044 62.7531 310.466 65.4443 306.676C68.1354 302.887 85.0161 302.887 91.2546 306.065C92.9672 306.432 98.2271 315.355 97.9825 317.922Z",
    fill: "url(#paint17_linear_83_7410)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M178.471 311.077C178.471 311.077 172.599 312.788 161.345 313.522C153.761 314.01 143.731 314.133 131.498 312.91C131.498 312.91 133.089 306.432 125.26 298.364C125.382 298.364 155.351 293.719 178.471 311.077Z",
    fill: "url(#paint18_radial_83_7410)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.1929 289.93C31.1929 289.93 42.6913 293.352 54.3121 289.808C54.3121 289.808 43.7923 291.397 31.1929 289.93Z",
    fill: "#75272C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.1647 282.841C78.1647 283.452 77.6754 284.063 76.9415 284.063C76.3299 284.063 75.7183 283.574 75.7183 282.841C75.7183 282.229 76.2076 281.618 76.9415 281.618C77.6754 281.74 78.1647 282.229 78.1647 282.841Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.4528 282.841C36.4528 283.452 35.9635 284.063 35.2296 284.063C34.618 284.063 34.0063 283.574 34.0063 282.841C34.0063 282.229 34.4956 281.618 35.2296 281.618C35.9635 281.74 36.4528 282.229 36.4528 282.841Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.517 304.721C33.517 304.721 33.3947 304.721 33.2724 304.599C31.8045 303.987 26.9115 301.787 22.0186 297.264C22.2632 297.02 22.5079 296.775 22.7525 296.653C24.9543 294.697 27.7678 292.986 31.0705 292.375C31.1929 292.375 29.9696 299.342 33.517 304.721Z",
    fill: "url(#paint19_linear_83_7410)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.2144 318.044C70.2144 318.044 65.8107 315.477 67.2786 309.977C67.2786 309.977 67.7679 314.377 70.826 318.044H70.2144Z",
    fill: "#BD4C3A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.6974 318.044C76.6974 318.044 74.4956 313.032 76.0858 309.977C76.0858 309.977 73.15 310.588 76.4528 318.044H76.6974Z",
    fill: "#BD4C3A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.4434 306.799C65.4434 306.799 67.8898 308.877 78.0427 308.877C88.1957 308.877 93.7002 306.31 97.9816 303.254C97.9816 303.254 91.6207 305.576 89.1742 305.21C86.7278 304.843 74.9846 300.809 65.4434 306.799Z",
    fill: "#FF9F30"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.345 313.521C153.761 314.01 143.731 314.133 131.498 312.91C131.498 312.91 133.089 306.432 125.26 298.364C125.382 298.364 141.896 307.654 161.345 313.521Z",
    fill: "#CE777C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.095 222.09C87.095 222.09 76.9421 222.212 69.358 229.302C61.7739 236.514 58.7158 246.903 58.7158 246.903C58.7158 246.903 59.6944 233.58 64.2204 226.246C68.7464 218.912 75.5966 217.812 75.5966 217.812C75.5966 217.812 81.7128 219.156 87.095 222.09Z",
    fill: "#9D3D3A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.2783 219.768C67.2783 219.768 60.4282 221.968 56.2691 233.947C52.1101 245.926 49.2967 259.494 49.2967 259.494C49.2967 259.494 46.2386 243.359 49.2967 233.947C52.3548 224.535 56.6361 221.235 56.6361 221.235C56.6361 221.235 63.3639 218.545 67.2783 219.768Z",
    fill: "#9D3D3A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.7979 230.768C37.7979 230.768 37.9202 238.347 41.4676 250.326C41.4676 250.326 41.4676 231.135 49.0517 223.923C49.0517 223.923 42.3238 226.49 37.7979 230.768Z",
    fill: "#9D3D3A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.403 265.85C124.403 265.85 124.648 271.106 113.761 282.107C102.874 293.108 87.7058 292.986 78.1646 293.841C78.1646 293.841 89.1737 297.142 104.464 293.841C119.755 290.541 130.03 271.961 130.03 271.961L124.403 265.85Z",
    fill: "#9D3D3A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.762 252.16C113.762 252.16 115.107 269.762 109.97 276.24C100.061 288.708 85.9941 288.708 85.9941 288.708C85.9941 288.708 106.545 287.242 115.107 277.952C123.67 268.662 119.633 260.35 119.633 260.35L113.762 252.16Z",
    fill: "#9D3D3A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.6787 304.354C94.6787 304.354 102.752 304.598 107.278 313.888C107.278 313.888 107.523 305.209 103.853 300.687C103.853 300.687 100.306 303.376 94.6787 304.354Z",
    fill: "#9D3D3A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.891 297.876C107.891 297.876 116.698 299.342 122.814 312.911C122.814 312.911 123.67 303.132 114.129 292.375C114.251 292.375 110.092 296.409 107.891 297.876Z",
    fill: "#9D3D3A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132.722 268.662C132.722 268.662 149.603 280.763 148.135 298.854L155.841 300.443C155.841 300.443 156.575 278.563 137.86 267.439L132.722 268.662Z",
    fill: "#9D3D3A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141.896 266.339C141.896 266.339 156.208 270.372 159.755 288.708C159.755 288.708 161.223 277.829 151.927 263.649L141.896 266.339Z",
    fill: "#9D3D3A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M159.878 262.305C159.878 262.305 170.643 276.117 166.606 297.875C166.606 297.875 176.27 279.296 172.355 263.038C172.355 262.916 167.829 260.96 159.878 262.305Z",
    fill: "#9D3D3A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M184.465 272.206C184.465 272.206 192.416 283.452 184.465 303.254C184.465 303.254 194.006 293.842 194.128 282.474L184.465 272.206Z",
    fill: "#9D3D3A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M204.282 293.597C204.282 293.597 204.282 305.209 200.245 311.687C200.245 311.687 208.441 304.598 209.419 296.653C209.419 296.653 207.829 296.653 207.218 296.408C206.851 296.164 204.282 293.597 204.282 293.597Z",
    fill: "#9D3D3A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.2935 237.246C32.2935 237.246 40.9785 245.803 60.6727 244.458C80.2445 243.114 91.6207 226.979 91.6207 226.979C91.6207 226.979 80.4892 220.5 62.6298 221.6C44.7705 222.701 32.2935 237.246 32.2935 237.246Z",
    fill: "#FFC763"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132.11 270.372C132.11 270.372 145.199 274.773 161.468 272.939C177.615 271.106 178.594 267.438 178.594 267.438C178.594 267.438 176.147 262.916 165.016 262.671C153.762 262.305 132.11 270.372 132.11 270.372Z",
    fill: "#FFC763"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M211.866 291.519C211.866 291.519 228.258 302.275 257.248 306.431C286.239 310.587 294.313 298.119 294.313 298.119C294.313 298.119 293.823 297.019 288.441 298.119C283.059 299.219 271.805 302.52 251.132 301.786C230.582 301.053 211.866 291.519 211.866 291.519Z",
    fill: "#FFC763"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M225.933 317.922C225.566 317.678 219.45 314.5 213.333 315.355C206.85 316.333 198.043 317.311 192.049 316.7C186.178 316.089 179.083 311.321 178.593 311.077H178.471C178.349 311.077 178.226 311.077 178.104 311.199C177.493 311.321 176.881 311.444 176.269 311.688C175.902 311.81 175.535 311.81 175.168 311.933C156.575 315.722 134.312 313.399 131.988 313.033C131.866 313.033 131.743 313.033 131.743 313.033C131.743 312.91 131.621 310.955 124.159 305.943C116.208 300.565 105.811 299.342 105.811 299.342C118.41 290.664 127.829 275.751 127.829 275.751C127.829 281.985 127.829 287.73 127.829 287.73C127.829 287.73 154.373 289.686 165.872 296.042C170.031 298.364 174.312 308.021 184.465 310.832C194.74 313.644 209.297 310.955 214.434 311.444C219.572 312.177 225.566 317.555 225.933 317.922Z",
    fill: "url(#paint20_linear_83_7410)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176.636 284.918C169.542 285.774 175.046 304.109 182.753 308.265C190.459 312.299 199.756 310.221 201.958 306.798C204.159 303.498 190.214 283.329 176.636 284.918Z",
    fill: "#FFC763"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M222.997 312.91C222.997 312.91 226.667 316.944 230.337 316.577C230.337 316.577 229.603 316.944 228.991 317.188C228.869 317.188 226.177 317.311 222.997 312.91Z",
    fill: "#BD4C3A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M175.413 311.688C175.413 311.688 169.175 305.454 162.447 302.276C162.447 302.276 170.276 304.599 180.673 312.3L175.413 311.688Z",
    fill: "#75272C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M199.266 288.22C199.266 288.22 206.972 295.309 208.807 295.798C210.642 296.287 211.253 295.921 215.657 297.265C220.061 298.61 234.617 308.266 235.718 309.733C236.819 311.2 234.128 313.156 234.128 313.156C234.128 313.156 235.596 310.344 234.74 309.611C233.883 308.877 216.391 297.51 213.211 297.143C210.152 296.776 209.296 297.265 207.706 297.143C206.238 296.776 199.266 288.22 199.266 288.22Z",
    fill: "#932F31"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.235 243.847C109.235 243.847 123.303 254.848 125.382 260.715L119.266 256.315C119.266 256.315 122.446 257.781 123.914 265.116C123.914 265.116 113.272 253.503 109.235 243.847Z",
    fill: "url(#paint21_radial_83_7410)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.235 243.847C109.235 243.847 111.437 254.603 105.933 263.893C105.933 263.893 112.66 259.859 113.027 250.692L109.235 243.847Z",
    fill: "url(#paint22_radial_83_7410)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M233.273 314.255C233.273 314.255 270.949 316.455 296.025 312.666C296.025 312.666 261.774 315.477 234.252 312.91L233.273 314.255Z",
    fill: "#BD4C3A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M186.055 315.111C186.055 315.111 190.336 316.945 199.021 316.7C207.461 316.456 212.354 314.989 215.657 315.234C215.657 315.234 213.945 315.111 209.296 316.089C204.648 317.067 192.293 318.412 186.055 315.111Z",
    fill: "#BD4C3A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.7524 285.285L63.2417 282.474L71.3151 283.329V287.852C71.1928 287.852 64.832 288.096 62.7524 285.285Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.5654 283.085L26.1771 280.763L30.8254 281.374L31.6816 285.408C31.6816 285.408 26.2994 285.53 25.5654 283.085Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.2503 268.172C72.2931 268.784 71.8038 272.817 72.4154 274.406C73.0271 275.995 79.8772 278.44 80.7335 277.096C81.7121 275.629 77.6754 267.195 74.2503 268.172Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.9419 271.106C35.2293 270.373 34.3731 275.629 34.4954 276.851C34.4954 278.073 37.0642 279.785 37.7981 279.296C38.5321 278.685 38.0428 271.473 36.9419 271.106Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_83_7410",
    x1: 183.294,
    y1: 293.598,
    x2: 303.33,
    y2: 293.598,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C93343"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5894,
    stopColor: "#FF4C32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9829,
    stopColor: "#FF8E27"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_83_7410",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(286.38 305.86) scale(13.3047 13.295)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0171145,
    stopColor: "#FFC772"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC381"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_83_7410",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(166.327 265.325) scale(60.075 60.0313)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0171145,
    stopColor: "#FF8E27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6543"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_83_7410",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.4242 239.86) scale(55.1994 55.1592)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0171145,
    stopColor: "#FF8E27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6543"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_83_7410",
    x1: 100.089,
    y1: 245.897,
    x2: 132.086,
    y2: 245.897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3802,
    stopColor: "#9A4327"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9972,
    stopColor: "#592930"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_83_7410",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(71.2279 294.348) scale(42.156 42.1253)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0171145,
    stopColor: "#FFC772"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC381"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_83_7410",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(76.7538 269.619) scale(19.4363 19.4222)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0171145,
    stopColor: "#FFEC72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBD8C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_83_7410",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29.9227 269.409) scale(14.0992 14.0889)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0171145,
    stopColor: "#FFC772"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9D48"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_83_7410",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(117.832 251.362) scale(9.50361 9.49669)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0171145,
    stopColor: "#FFC772"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9D48"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_83_7410",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.5822 267.656) scale(13.9525 13.9424)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0171145,
    stopColor: "#FF8E27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6543"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_83_7410",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(32.1235 269.363) rotate(-2.14316) scale(10.6125 10.0985)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0171145,
    stopColor: "#FF8E27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6543"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_83_7410",
    x1: 31.8007,
    y1: 285.4,
    x2: 31.5409,
    y2: 278.453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9829,
    stopColor: "#FBC9CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_83_7410",
    x1: 73.6978,
    y1: 288.078,
    x2: 73.6978,
    y2: 275.969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9829,
    stopColor: "#FBC9CE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_83_7410",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(69.984 285.343) scale(7.68416 7.67857)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0171145,
    stopColor: "#FFC710"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7682,
    stopColor: "#FF7700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE4B00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_83_7410",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(30.9726 283.86) rotate(-2.14316) scale(5.04142 4.79724)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0171145,
    stopColor: "#FFC710"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7682,
    stopColor: "#FF7700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE4B00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_83_7410",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(42.591 292.98) scale(8.60098 8.59473)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0171145,
    stopColor: "#9A4327"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9469,
    stopColor: "#8B3B30"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_83_7410",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.596 305.995) scale(6.96183 6.95677)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0171145,
    stopColor: "#9A4327"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9469,
    stopColor: "#8B3B30"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_83_7410",
    x1: 64.6112,
    y1: 310.941,
    x2: 97.9882,
    y2: 310.941,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0171145,
    stopColor: "#FF8E27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7C3E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_83_7410",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(151.906 305.845) scale(19.6254 19.6112)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0171145,
    stopColor: "#FFC772"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC381"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_83_7410",
    x1: 27.8358,
    y1: 304.742,
    x2: 27.8358,
    y2: 292.367,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0171145,
    stopColor: "#E08893"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF2EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_83_7410",
    x1: 105.871,
    y1: 296.855,
    x2: 225.874,
    y2: 296.855,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0171145,
    stopColor: "#E08893"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF2EF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_83_7410",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(117.268 254.506) scale(9.44244 9.43558)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0171145,
    stopColor: "#FFC772"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC381"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial_83_7410",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(109.393 253.924) scale(7.53432 7.52883)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0171145,
    stopColor: "#FFC772"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC381"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_83_7410"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 320,
    height: 105,
    fill: "white",
    transform: "translate(0 215)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTigerSad);
export default __webpack_public_path__ + "static/media/tiger_sad.94d25d80cff345e4eba67e993daff98f.svg";
export { ForwardRef as ReactComponent };